// extracted by mini-css-extract-plugin
export var base = "_1j-0";
export var updateBanner = "_1j-1";